import { css as _css } from "@emotion/react";
/** @jsx jsx */
import { Checkbox } from '@datacamp/waffles/checkbox';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const CheckboxItemWrapper = _ref => {
  let {
    checked,
    children,
    disabled,
    onChange,
    value
  } = _ref;
  return jsx("div", {
    css: /*#__PURE__*/_css({
      alignItems: 'center',
      display: 'flex',
      height: 30,
      'label:first-of-type': {
        flexGrow: 1
      },
      marginTop: 16,
      span: {
        borderColor: tokens.colors.greyMedium,
        fontSize: '100%'
      }
    }, "production" === "production" ? "" : ";label:CheckboxItemWrapper;", "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0NoZWNrYm94SXRlbVdyYXBwZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCTSIsImZpbGUiOiIuLi8uLi9zcmMvY29tcG9uZW50cy9DaGVja2JveEl0ZW1XcmFwcGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgQ2hlY2tib3ggfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy9jaGVja2JveCc7XG5pbXBvcnQgeyB0b2tlbnMgfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy90b2tlbnMnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHR5cGUgeyBDb21wb25lbnRQcm9wcyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCAqIGFzIFJlYWN0IGZyb20gJ3JlYWN0JztcblxudHlwZSBDaGVja2JveFByb3BzID0gQ29tcG9uZW50UHJvcHM8dHlwZW9mIENoZWNrYm94PjtcblxuZXhwb3J0IGNvbnN0IENoZWNrYm94SXRlbVdyYXBwZXIgPSAoe1xuICBjaGVja2VkLFxuICBjaGlsZHJlbixcbiAgZGlzYWJsZWQsXG4gIG9uQ2hhbmdlLFxuICB2YWx1ZSxcbn06IENoZWNrYm94UHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQgPT4ge1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIGNzcz17e1xuICAgICAgICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgICAgICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgICAgICBoZWlnaHQ6IDMwLFxuICAgICAgICAnbGFiZWw6Zmlyc3Qtb2YtdHlwZSc6IHtcbiAgICAgICAgICBmbGV4R3JvdzogMSxcbiAgICAgICAgfSxcbiAgICAgICAgbWFyZ2luVG9wOiAxNixcbiAgICAgICAgc3Bhbjoge1xuICAgICAgICAgIGJvcmRlckNvbG9yOiB0b2tlbnMuY29sb3JzLmdyZXlNZWRpdW0sXG4gICAgICAgICAgZm9udFNpemU6ICcxMDAlJyxcbiAgICAgICAgfSxcbiAgICAgIH19XG4gICAgPlxuICAgICAgPENoZWNrYm94XG4gICAgICAgIGNoZWNrZWQ9e2NoZWNrZWR9XG4gICAgICAgIGRpc2FibGVkPXtkaXNhYmxlZH1cbiAgICAgICAgb25DaGFuZ2U9e29uQ2hhbmdlfVxuICAgICAgICB2YWx1ZT17dmFsdWV9XG4gICAgICA+XG4gICAgICAgIHtjaGlsZHJlbn1cbiAgICAgIDwvQ2hlY2tib3g+XG4gICAgPC9kaXY+XG4gICk7XG59O1xuIl19 */")
  }, jsx(Checkbox, {
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    value: value
  }, children));
};